import { Component, Inject, Input, Output, EventEmitter, OnInit } from 'ng-metadata/core';
import './timestamp.component.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentTimestamp
 * @module mw.components.contentDocuments
 *
 * @param {date} [date] - A date object that will be converted to human readable timestamp.
 * @param {string} [link-url] - A link url that will tell the component to use a link or not.
 * @param {string} [timezone] - Timezone for date formatting.
 * @param {expression} [on-click] - Angular expression to evaluate when the component is clicked.  $event is the ng-click event.
 *
 * @description
 * `<mw-content-document-timestamp>` provides a means for displaying a human readable timestamp for when the document was published.
 *
 * @usage
 * <hljs hljs-language="html">
 *
 *   <mw-content-document-timestamp date="$ctrl.date" link-url="$ctrl.linkUrl"></mw-content-document-timestamp>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-content-document-timestamp',
    template: `
        <a  ng-href="{{::$ctrl.linkUrl}}"
            target="_blank"
            ng-if="::$ctrl.date && $ctrl.linkUrl"
            ng-click="$ctrl.handleTimestampClick($event);"
            data-tracking-event="documentOperation/open">
            <span class="mw-content-document-timestamp">{{ ::$ctrl.formattedTimestamp }}</span>
        </a>
        <span ng-if="::$ctrl.date && !$ctrl.linkUrl" class="mw-content-document-timestamp">{{ ::$ctrl.formattedTimestamp }}</span>
    `
})
export class TimestampComponent implements OnInit {
    @Input('<') date: any;
    @Input('<') linkUrl: string;
    @Input('<') timezone: string;
    @Output() onClick = new EventEmitter<ng.IAngularEvent>();

    formattedTimestamp = '';
    private timestampFilter;

    constructor(@Inject('$filter') private $filter) {
        'ngInject';

        this.timestampFilter = this.$filter('mwTimestamp');
    }

    ngOnInit() {
        if (typeof this.date === 'number' ) {
            this.date = new Date(this.date);
        }

        this.formattedTimestamp = this.timestampFilter(this.date, this.timezone);
    }

    handleTimestampClick(event: ng.IAngularEvent) {
        this.onClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/timestamp/timestamp.component.ts